import React, { useState, useMemo, useEffect } from 'react';
import Filters from '../../../components/Filters';
import Wrapper from '../../../components/Wrapper';
import { buttons } from './helper';
import { useSelector } from 'react-redux';
import Typograpy from '../../../components/Typograpy';
import Diagramma from '../../../components/Diagramma';
import Spinner from '../../../components/Spinner';
import reports from '../../../services/reports';
import { checkWorkAndPlan } from '../../../utils/makeReport';
import RangePicker from '../../../components/RangePicker';

export default () => {
  const { selectedDate } = useSelector((state) => state.selectedDateReducer);
  const { regions, groups } = useSelector((state) => state.appReducer);
  const { groupId } = useSelector((state) => state.authReducer);
  const [active, setActive] = useState('all');
  const [group, setgroup] = useState(undefined);
  const [filters, setFilters] = useState([]);

  const dateQuery = useMemo(
    () => selectedDate.every((item) => item !== '') && selectedDate,
    [selectedDate]
  );

  const [loading, setLoading] = useState(false);

  const [groupReport, setgroupReport] = useState([]);

  const handleActive = (item) => {
    if (item.value === 'all') {
      setgroup(undefined);
    } else {
      setgroup(item?.id);
    }
    setActive(item?.value);
  };

  const fetchReportBygroups = async () => {
    try {
      setLoading(true);

      const data = {
        start: selectedDate[0],
        end: selectedDate[1],
        group: group,
      };
      const secId = groups.find((itm) => itm._id === groupId);
      setFilters([
        ...buttons,
        {
          id: secId._id,
          title: secId.title,
          value: 'group',
        },
      ]);

      const reportsData = await reports.getAllByRegions(data);
      const report = reportsData[0]?.regions.map((item) => {
        const reg = regions.find((e) => e._id === item.region);
        return {
          id: Date.now(),
          regionName: `${reg ? reg.title : ''}:`,
          personName: '',
          percent: checkWorkAndPlan(item.work, item.plan),
        };
      });

      setgroupReport(
        report ? report.sort((a, b) => b.percent - a.percent) : []
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (!selectedDate.every((item) => item === '')) {
      fetchReportBygroups();
    }
  }, [dateQuery, regions, groups, group]);

  const elements = {
    all: (
      <>
        {groupReport.length === 0 ? (
          <h2 style={{ textAlign: 'center', fontSize: '26px', color: 'black' }}>
            Танланган вақт кесими бўйича натижалар аниқланмади!
          </h2>
        ) : (
          <>
            <Typograpy>
              4 та гуруҳ раҳбарлари томонидан режалаштирилган <br /> ва амалга
              оширилган ишлар таҳлили
            </Typograpy>
            <Diagramma data={groupReport} />
          </>
        )}
      </>
    ),
    group: (
      <>
        {groupReport.length === 0 ? (
          <h2 style={{ textAlign: 'center', fontSize: '26px', color: 'black' }}>
            Танланган вақт кесими бўйича натижалар аниқланмади!
          </h2>
        ) : (
          <>
            <Typograpy>
              {filters[1]?.title} раҳбарлари томонидан режалаштирилган <br /> ва
              амалга оширилган ишлар таҳлили
            </Typograpy>
            <Diagramma data={groupReport} />
          </>
        )}
      </>
    ),
  };

  // if (loading) return <Spinner maxHeight='100%' />;
  return (
    <Wrapper>
      <div style={{ width: '100%', padding: '20px 0' }}>
        <RangePicker />
      </div>
      <Filters
        list={filters}
        active={active}
        handleActive={handleActive}
      />
      {loading ? <Spinner /> : elements[active]}
    </Wrapper>
  );
};
